import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  LIST_PADDING,
  LIST_TOP_MARGIN,
  MAX_CONTENT_HEIGHT,
  MAX_MOBILE_CONTENT_HEIGHT,
  SAFE_LIST_AREA_HEIGHT,
  SEARCH_FIELD_BOX_HEIGHT,
  SEARCH_FIELD_BOX_PADDING,
  TABS_HEAIGHT,
} from '../../../../styles/constants';

export const useStyles = makeStyles<{ tabsHidden: boolean }>()((
  theme,
  { tabsHidden },
) => {
  const tabsHeight = tabsHidden ? '0px' : TABS_HEAIGHT;
  const searchFieldHeight = !tabsHidden
    ? SEARCH_FIELD_BOX_HEIGHT
    : `calc(${SEARCH_FIELD_BOX_HEIGHT} - ${SEARCH_FIELD_BOX_PADDING})`;
  return {
    trainingListWrapper: {},
    trainingListSearch: {
      marginTop: !tabsHidden ? SEARCH_FIELD_BOX_PADDING : '0px',
    },
    trainingItemListHeader: {
      width: '100%',
    },
    trainingItemListBody: {
      position: 'relative',
      paddingTop: LIST_PADDING,
      paddingBottom: LIST_PADDING,
      marginTop: LIST_TOP_MARGIN,
      borderTop: `1px solid ${theme.palette.paper.borderColor}`,
      maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
      height: `calc(${MAX_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
      overflowY: 'auto',

      [theme.breakpoints.down('md')]: {
        maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
        height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
      },
    },
    trainingItemListBodyWithButtons: {
      maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
      height: `calc(${MAX_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,

      [theme.breakpoints.down('md')]: {
        maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
        height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${tabsHeight} - ${searchFieldHeight} - ${LIST_TOP_MARGIN})`,
      },
    },
  };
});
